import { Component, OnInit, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-company-main',
  templateUrl: './company-main.component.html',
  styleUrls: ['./company-main.component.css']
})
export class CompanyMainComponent implements OnInit {

  @Output() onSelectViewMore = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  viewPage(pageKey: string) {
    let groupKey = 2;
    if (pageKey === 'rnd_intro') {
      groupKey = 3;
    }
    this.onSelectViewMore.emit({
      groupKey: groupKey,
      pageKey: pageKey
    });
  }

}
